import { Box } from "@chakra-ui/react";
import {
  ColorIcon,
  colors,
  customEvent,
  HStack,
  NextLink,
  VStack,
  SlidingMenu,
  Image,
  getCdnImageSrc,
  // call,
} from "goi_common";

import { useState } from "react";

import HospiceFeeSection from "./components/HospiceFeeSection";
import HospiceInformationSection from "./components/HospiceInformationSection";
import HospiceReviewSection from "./components/HospiceReviewSection";

import ImageSlideSection from "./components/ImageSlideSection";
import MainInfoSection from "./components/MainInfoSection";

function HospiceDetailContainer({ hospice }: { hospice: any }) {
  const [current, setCurrent] = useState<number>(0);

  return (
    <VStack width="100%" alignItems="center">
      <VStack width="100%" maxWidth="480px">
        <HStack
          width="100%"
          height="50px"
          justifyContent="center"
          alignItems="center"
          position="relative"
        >
          <Box position="absolute" left="10px">
            <a
              href="https://prime.goifuneral.co.kr/?utm_campaign=hospice_detail_back_btn"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "hospice_detail",
                    trigger_and_target: "back-uv_hsps_serch",
                  },
                });
              }}
            >
              <ColorIcon
                name="thinArrow"
                css={{ transform: "rotateZ(180deg)" }}
                size={30}
                color={colors.gray700}
              />
            </a>
          </Box>
          <div className="button">{hospice.name}</div>
        </HStack>
        <ImageSlideSection images={hospice.images} name={hospice.name} />

        <MainInfoSection name={hospice.name} hospice={hospice} />

        <SlidingMenu
          current={current}
          setCurrent={(v) => {
            customEvent({
              newGtm: {
                path: "hospice_detail",
                trigger_and_target:
                  current === 0
                    ? "tab-info_tab"
                    : current === 1
                    ? "tab-facility_tab"
                    : current === 2
                    ? "tab-review_tab"
                    : "",
              },
            });
            setCurrent(v);
          }}
          items={["기본 정보", "병실/시설 현황", `후기`]}
        />

        <VStack>
          <NextLink
            href="https://prime.goifuneral.co.kr/?utm_campaign=hospice_banner"
            event={{
              newGtm: {
                path: "hospice_detail",
                trigger_and_target: "uv_prime",
              },
            }}
          >
            <Image
              src={getCdnImageSrc("direct/100_banner_2.png")}
              alt=""
              width="100%"
            />
          </NextLink>
        </VStack>

        {current === 0 && <HospiceInformationSection hospice={hospice} />}
        {current === 1 && <HospiceFeeSection hospice={hospice} />}
        {current === 2 && <HospiceReviewSection />}
      </VStack>
    </VStack>
  );
}
export default HospiceDetailContainer;
